<!--<div class="component-heading" fxLayout="column" fxLayoutAlign="center start">
  <span *ngIf="contextTitle" matTooltip="{{contextTitle}}">{{contextTitle}}</span>
</div>


<div class="rest-of" fusePerfectScrollbar>
  <div *ngFor="let conversation of conversationList"
       (click)="navigateToConversation(conversation)">
    <div fxLayout="row" class="conversation-container">
      <div fxLayout="column" class="full-grow-no-shrink-no-basis">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <span class="user-name" class="full-grow-no-shrink-no-basis">{{conversation?.title}}</span>
          <span class="timing">{{conversation.createdDate | timeAgo}}</span>
        </div>
        <div class="description-container">
          <div class="description" class="full-grow-no-shrink-no-basis">Total message: {{conversation.messageCount? conversation.messageCount: 0}}</div>
        </div>
      </div>
    </div>

  </div>
  <div *ngIf="conversationList?.length === 0" class="empty-content" fxLayout="row" fxLayoutAlign="center center">
    No Conversation exists.
  </div>

</div>-->
<conversation-list
  [contextId]="contextId"
  [conversationComponentName]="collaborationComponentName"
  [hideCreateConversationBar]="true"
  [conversationListComponentName]="conversationListComponentName"
></conversation-list>
